<template>
	<div class="answer-val answer-true-false-no position-rel display-flex justify-content-between"
		:class="`answer-${parent.type}`"
	>
		<label class="display-flex-center">
			<b v-if="dataSource.code">{{ dataSource.code }} </b>
			<span v-html="dataSource.content"></span>
		</label>
		<input 
			v-if="parent.layoutId === 1"
			:name="`${nameField}_${location}`" 
			type="text"
			class="form-control input-hide-place"
			placeholder="Đ/S" 
			:value="dataSource.answerContent"
			@change="changeAnswer($event, {location, type: parent.type, questionId: dataSource.questionId})"
      autocomplete="off"
		/>
		<div class="choice-radio display-flex-center" v-else-if="parent.layoutId === 2">
			<div class="radio-custom">
				<input type="radio" :name="`correct_${location}`" :checked="dataSource.answerContent && dataSource.answerContent === 'dđ'" @change="choiceAnswer(true, location, parent.type)">
				<label class="w-18 margin-0"></label>
			</div>
			<div class="radio-custom">
				<input type="radio" :name="`correct_${location}`" :checked="dataSource.answerContent && dataSource.answerContent === 's'" @change="choiceAnswer(false, location, parent.type)">
				<label class="w-18 margin-0"></label>
			</div>
		</div>
	</div>
</template>

<script>
	import mixinsQuestionPreview from './../../_store/mixinsQuestionPreview'

	export default {
		name: 'TrueFalseAnswer',
		mixins: [ mixinsQuestionPreview ],
		data () {
			return {

			}
		},
		methods: {
			choiceAnswer(val, index, type) {
				this.changeAnswer({target: {value: val ? 'dđ' : 's'}}, {location: index, type, questionId: this.dataSource.questionId});
			}
		}
	}
</script>

<style lang="scss" scoped>
</style>